/**
 * Firebase Configuration
 * Initializes Firebase app and exports service instances
 */

import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

function validateConfig(): void {
  const requiredKeys = [
    'REACT_APP_FIREBASE_API_KEY',
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'REACT_APP_FIREBASE_PROJECT_ID',
  ];

  const missingKeys = requiredKeys.filter(
    (key) => !process.env[key]
  );

  if (missingKeys.length > 0 && process.env.NODE_ENV === 'development') {
    console.warn(
      `Firebase config missing: ${missingKeys.join(', ')}. ` +
      'Authentication features will not work until configured.'
    );
  }
}

function initializeFirebase(): FirebaseApp | null {
  validateConfig();

  if (!firebaseConfig.apiKey) {
    return null;
  }

  if (getApps().length === 0) {
    return initializeApp(firebaseConfig);
  }
  return getApps()[0];
}

const app = initializeFirebase();

export const auth: Auth | null = app ? getAuth(app) : null;
export const db: Firestore | null = app ? getFirestore(app) : null;
export const storage: FirebaseStorage | null = app ? getStorage(app) : null;

export function isFirebaseConfigured(): boolean {
  return app !== null;
}

export default app;
